import { Link } from "react-router-dom";


const PrivacyPolicy = () => {
    return(
        <div className="w-screen h-screen bg-whiteColor flex flex-col justify-center items-center space-y-[2%]">
           <iframe
          src="https://www.termsfeed.com/live/62824dcd-bd5c-4937-9751-18eee85e545c"
          className="w-full h-full"
          frameBorder="0"
          title="Popup Content"
        />
        <div className="flex space-x-2 justify-center items-center">
        <h1>Our Patner: </h1>
        <Link to="https://www.lalpathlabs.com/privacy-policy" target="_blank" className="font-normal text-blue-600 underline">
          Dr Lal PathLabs Privacy Policy
        </Link>
        </div>
      </div>
    )
}

export default PrivacyPolicy;